import { api } from "@/frontend/services/api";
import type {
  ApiResponse,
  PoolParticipantResponseDTO,
  AddPoolParticipantRequestDTO,
  UpdatePoolParticipantRequestDTO,
  JoinPoolRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/pool-participants/private";

export interface PoolParticipantWithUserDTO extends PoolParticipantResponseDTO {
  email?: string | null;
  expiresAt?: string | null;
  invitationId?: string | null;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
    userTag: string;
  } | null;
}

export interface PaginatedPoolParticipantsResponse {
  success: boolean;
  data: PoolParticipantWithUserDTO[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export const poolParticipantService = {
  join: (data: JoinPoolRequestDTO) =>
    api.post<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/join`, data),
  listByPool: (poolId: string, statusId?: string, page: number = 1, pageSize: number = 20) => {
    const params = new URLSearchParams();
    if (statusId) params.append("statusId", statusId);
    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());
    
    const url = `${BASE_URL}/pool/${poolId}?${params.toString()}`;
    return api.get<PaginatedPoolParticipantsResponse>(url);
  },
  add: (data: AddPoolParticipantRequestDTO) =>
    api.post<ApiResponse<PoolParticipantResponseDTO>>(BASE_URL, data),
  update: (poolId: string, userId: string, data: UpdatePoolParticipantRequestDTO) =>
    api.put<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/${poolId}/${userId}`, data),
  remove: (poolId: string, userId: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${poolId}/${userId}`),
  ban: (poolId: string, userId: string, reason?: string) =>
    api.patch<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/${poolId}/${userId}/ban`, { reason }),
  unban: (poolId: string, userId: string) =>
    api.patch<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/${poolId}/${userId}/unban`),
  kick: (poolId: string, userId: string, reason?: string) =>
    api.patch<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/${poolId}/${userId}/kick`, { reason }),
  unkick: (poolId: string, userId: string) =>
    api.patch<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL}/${poolId}/${userId}/unkick`),
};
